var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "matching-to-pay-wrapper",
      style: `paddingTop:${_vm.barHeight}px`,
    },
    [
      _c("div", { staticClass: "content-wrapper" }, [
        _c("img", {
          staticClass: "back",
          attrs: {
            src: require("./images/back.png"),
            alt: "back",
            width: "24",
            height: "24",
          },
          on: { click: _vm.closeWeb },
        }),
        _c("div", { staticClass: "title-wrapper" }, [
          _c("span", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.$t("lang.matchingToPay.title"))),
          ]),
          _c("img", {
            attrs: {
              src: _vm.getMatchImg("beans"),
              alt: "image",
              width: "46px",
              height: "46px",
            },
          }),
        ]),
        _c("div", { staticClass: "subtitle-wrapper" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("lang.matchingToPay.subtitle1")) + " "),
          ]),
          _c("span", { staticClass: "number" }, [_vm._v("30")]),
          _c("span", [_vm._v(_vm._s(_vm.$t("lang.matchingToPay.subtitle2")))]),
        ]),
        _c("div", { staticClass: "text-wrapper" }, [
          _c("div", { staticClass: "text-layout-wrapper" }, [
            _c("div", { staticClass: "layout-wrapper" }, [
              _c("p", { staticClass: "text" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("lang.matchingToPay.text1-1"))),
                ]),
                _c("img", {
                  staticClass: "coin",
                  attrs: { src: _vm.getMatchImg("beans"), alt: "image" },
                }),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("lang.matchingToPay.text1-2"))),
                ]),
              ]),
              _c("br"),
              _c("p", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("lang.matchingToPay.text2"))),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }